"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = require("./extend");
var serialize_object_1 = require("./serialize-object");
var globals = {};
var jsonpRequests = 0;
var RequestResponse = /** @class */ (function () {
    function RequestResponse(obj) {
        Object.assign(this, obj);
    }
    return RequestResponse;
}());
var RequestError = /** @class */ (function (_super) {
    __extends(RequestError, _super);
    function RequestError(obj) {
        var _this = _super.call(this) || this;
        Object.assign(_this, obj);
        return _this;
    }
    return RequestError;
}(Error));
var request = function (requestOptions) {
    return new Promise(function (resolve, reject) {
        var globalsNoCallbacks = extend_1.extend({}, globals);
        'beforeCreate beforeOpen beforeSend error complete success statusCode'
            .split(' ')
            .forEach(function (callbackName) {
            delete globalsNoCallbacks[callbackName];
        });
        var defaults = extend_1.extend({
            url: window.location.toString(),
            method: 'GET',
            data: false,
            async: true,
            cache: true,
            user: '',
            password: '',
            headers: {},
            xhrFields: {},
            statusCode: {},
            processData: true,
            dataType: 'text',
            contentType: 'application/x-www-form-urlencoded',
            timeout: 0,
        }, globalsNoCallbacks);
        var proceedRequest;
        var options = extend_1.extend({}, defaults, requestOptions);
        if (requestOptions.abortController) {
            options.abortController = requestOptions.abortController;
        }
        if (options.abortController && options.abortController.canceled) {
            reject(new RequestError({ options: options, status: 'canceled', message: 'canceled' }));
            return;
        }
        // Function to run XHR callbacks and events
        function fireCallback(callbackName) {
            var data = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                data[_i - 1] = arguments[_i];
            }
            /*
            Callbacks:
            beforeCreate (options),
            beforeOpen (xhr, options),
            beforeSend (xhr, options),
            error (xhr, status, message),
            complete (xhr, status),
            success (response, status, xhr),
            statusCode ()
          */
            var globalCallbackValue;
            var optionCallbackValue;
            if (globals[callbackName]) {
                globalCallbackValue = globals[callbackName].apply(globals, data);
            }
            if (options[callbackName]) {
                optionCallbackValue = options[callbackName].apply(options, data);
            }
            if (typeof globalCallbackValue !== 'boolean')
                globalCallbackValue = true;
            if (typeof optionCallbackValue !== 'boolean')
                optionCallbackValue = true;
            if (options.abortController &&
                options.abortController.canceled &&
                (callbackName === 'beforeCreate' ||
                    callbackName === 'beforeOpen' ||
                    callbackName === 'beforeSend')) {
                return false;
            }
            return globalCallbackValue && optionCallbackValue;
        }
        // Before create callback
        proceedRequest = fireCallback('beforeCreate', options);
        if (proceedRequest === false) {
            reject(new RequestError({ options: options, status: 'canceled', message: 'canceled' }));
            return;
        }
        // For jQuery guys
        if (options.type)
            options.method = options.type;
        // Parameters Prefix
        var paramsPrefix = options.url.indexOf('?') >= 0 ? '&' : '?';
        // UC method
        var method = options.method.toUpperCase();
        // Data to modify GET URL
        if ((method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') &&
            options.data) {
            var stringData = void 0;
            if (typeof options.data === 'string') {
                // Should be key=value string
                if (options.data.indexOf('?') >= 0) {
                    stringData = options.data.split('?')[1];
                }
                else {
                    stringData = options.data;
                }
            }
            else {
                // Should be key=value object
                stringData = serialize_object_1.serializeObject(options.data);
            }
            if (stringData.length) {
                options.url += paramsPrefix + stringData;
                if (paramsPrefix === '?')
                    paramsPrefix = '&';
            }
        }
        // JSONP
        if (options.dataType === 'json' && options.url.indexOf('callback=') >= 0) {
            var callbackName_1 = "f7jsonp_" + (Date.now() + (jsonpRequests += 1));
            var abortTimeout_1;
            var callbackSplit = options.url.split('callback=');
            var requestUrl = callbackSplit[0] + "callback=" + callbackName_1;
            if (callbackSplit[1].indexOf('&') >= 0) {
                var addVars = callbackSplit[1]
                    .split('&')
                    .filter(function (el) { return el.indexOf('=') > 0; })
                    .join('&');
                if (addVars.length > 0)
                    requestUrl += "&" + addVars;
            }
            // Create script
            var script_1 = document.createElement('script');
            script_1.type = 'text/javascript';
            script_1.onerror = function onerror() {
                clearTimeout(abortTimeout_1);
                fireCallback('error', null, 'scripterror', 'scripterror');
                reject(new RequestError({ options: options, status: 'scripterror', message: 'scripterror' }));
                fireCallback('complete', null, 'scripterror');
            };
            script_1.src = requestUrl;
            // Handler
            window[callbackName_1] = function jsonpCallback(data) {
                clearTimeout(abortTimeout_1);
                fireCallback('success', data);
                script_1.parentNode.removeChild(script_1);
                script_1 = null;
                delete window[callbackName_1];
                resolve(new RequestResponse({ options: options, data: data }));
            };
            document.querySelector('head').appendChild(script_1);
            if (options.timeout > 0) {
                abortTimeout_1 = setTimeout(function () {
                    script_1.parentNode.removeChild(script_1);
                    script_1 = null;
                    fireCallback('error', null, 'timeout', 'timeout');
                    reject(new RequestError({ options: options, status: 'timeout', message: 'timeout' }));
                }, options.timeout);
            }
            return;
        }
        // Cache for GET/HEAD requests
        if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') {
            if (options.cache === false) {
                options.url += paramsPrefix + "_nocache" + Date.now();
            }
        }
        // Create XHR
        var xhr = new XMLHttpRequest();
        if (options.abortController) {
            var aborted_1 = false;
            options.abortController.onAbort = function () {
                if (aborted_1)
                    return;
                aborted_1 = true;
                xhr.abort();
                reject(new RequestError({ options: options, xhr: xhr, status: 'canceled', message: 'canceled' }));
            };
        }
        // Save Request URL
        xhr.requestUrl = options.url;
        xhr.requestParameters = options;
        // Before open callback
        proceedRequest = fireCallback('beforeOpen', xhr, options);
        if (proceedRequest === false) {
            reject(new RequestError({ options: options, xhr: xhr, status: 'canceled', message: 'canceled' }));
            return;
        }
        // Open XHR
        xhr.open(method, options.url, options.async, options.user, options.password);
        // Create POST Data
        var postData = null;
        if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && options.data) {
            if (options.processData) {
                var postDataInstances = [ArrayBuffer, Blob, Document, FormData];
                // Post Data
                if (postDataInstances.indexOf(options.data.constructor) >= 0) {
                    postData = options.data;
                }
                else {
                    // POST Headers
                    var boundary = "---------------------------" + Date.now().toString(16);
                    if (options.contentType === 'multipart/form-data') {
                        xhr.setRequestHeader('Content-Type', "multipart/form-data; boundary=" + boundary);
                    }
                    else {
                        xhr.setRequestHeader('Content-Type', options.contentType);
                    }
                    postData = '';
                    var data = serialize_object_1.serializeObject(options.data);
                    if (options.contentType === 'multipart/form-data') {
                        data = data.split('&');
                        var newData = [];
                        for (var i = 0; i < data.length; i += 1) {
                            newData.push("Content-Disposition: form-data; name=\"" + data[i].split('=')[0] + "\"\r\n\r\n" + data[i].split('=')[1] + "\r\n");
                        }
                        postData = "--" + boundary + "\r\n" + newData.join("--" + boundary + "\r\n") + "--" + boundary + "--\r\n";
                    }
                    else if (options.contentType === 'application/json') {
                        postData = JSON.stringify(options.data);
                    }
                    else {
                        postData = data;
                    }
                }
            }
            else {
                postData = options.data;
                xhr.setRequestHeader('Content-Type', options.contentType);
            }
        }
        if (options.dataType === 'json' && (!options.headers || !options.headers.Accept)) {
            xhr.setRequestHeader('Accept', 'application/json');
        }
        // Additional headers
        if (options.headers) {
            Object.keys(options.headers).forEach(function (headerName) {
                if (typeof options.headers[headerName] === 'undefined')
                    return;
                xhr.setRequestHeader(headerName, options.headers[headerName]);
            });
        }
        // Check for crossDomain
        if (typeof options.crossDomain === 'undefined') {
            options.crossDomain =
                // eslint-disable-next-line
                /^([\w-]+:)?\/\/([^\/]+)/.test(options.url) && RegExp.$2 !== window.location.host;
        }
        if (!options.crossDomain) {
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        if (options.xhrFields) {
            extend_1.extend(xhr, options.xhrFields);
        }
        // Handle XHR
        xhr.onload = function onload() {
            if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
                var responseData = void 0;
                if (options.dataType === 'json') {
                    var parseError = void 0;
                    try {
                        responseData = JSON.parse(xhr.responseText);
                    }
                    catch (err) {
                        parseError = true;
                    }
                    if (!parseError) {
                        fireCallback('success', responseData, xhr.status, xhr);
                        resolve(new RequestResponse({ options: options, data: responseData, status: xhr.status, xhr: xhr }));
                    }
                    else {
                        fireCallback('error', xhr, 'parseerror', 'parseerror');
                        reject(new RequestError({ options: options, xhr: xhr, status: 'parseerror', message: 'parseerror' }));
                    }
                }
                else {
                    responseData =
                        xhr.responseType === 'text' || xhr.responseType === ''
                            ? xhr.responseText
                            : xhr.response;
                    fireCallback('success', responseData, xhr.status, xhr);
                    resolve(new RequestResponse({ options: options, data: responseData, status: xhr.status, xhr: xhr }));
                }
            }
            else {
                fireCallback('error', xhr, xhr.status, xhr.statusText);
                reject(new RequestError({ options: options, xhr: xhr, status: xhr.status, message: xhr.statusText }));
            }
            if (options.statusCode) {
                if (globals.statusCode && globals.statusCode[xhr.status]) {
                    globals.statusCode[xhr.status](xhr);
                }
                if (options.statusCode[xhr.status])
                    options.statusCode[xhr.status](xhr);
            }
            fireCallback('complete', xhr, xhr.status);
        };
        xhr.onerror = function onerror() {
            fireCallback('error', xhr, xhr.status, xhr.status);
            reject(new RequestError({ options: options, xhr: xhr, status: xhr.status, message: xhr.statusText }));
            fireCallback('complete', xhr, 'error');
        };
        // Timeout
        if (options.timeout > 0) {
            xhr.timeout = options.timeout;
            xhr.ontimeout = function () {
                fireCallback('error', xhr, 'timeout', 'timeout');
                reject(new RequestError({ options: options, xhr: xhr, status: 'timeout', message: 'timeout' }));
                fireCallback('complete', xhr, 'timeout');
            };
        }
        // Ajax start callback
        proceedRequest = fireCallback('beforeSend', xhr, options);
        if (proceedRequest === false) {
            reject(new RequestError({ options: options, xhr: xhr, status: 'canceled', message: 'canceled' }));
            return;
        }
        // Send XHR
        xhr.send(postData);
    });
};
function requestShortcut(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a = [], url = _a[0], data = _a[1], success = _a[2], error = _a[3], dataType = _a[4];
    if (typeof args[1] === 'function') {
        url = args[0], success = args[1], error = args[2], dataType = args[3];
    }
    else {
        url = args[0], data = args[1], success = args[2], error = args[3], dataType = args[4];
    }
    [success, error].forEach(function (callback) {
        if (typeof callback === 'string') {
            dataType = callback;
            if (callback === success) {
                success = undefined;
            }
            else {
                error = undefined;
            }
        }
    });
    dataType = dataType || (method === 'json' || method === 'postJSON' ? 'json' : undefined);
    var requestOptions = {
        url: url,
        method: method === 'post' || method === 'postJSON' ? 'POST' : 'GET',
        data: data,
        success: success,
        error: error,
        dataType: dataType,
    };
    if (method === 'postJSON') {
        extend_1.extend(requestOptions, {
            contentType: 'application/json',
            processData: false,
            crossDomain: true,
            data: typeof data === 'string' ? data : JSON.stringify(data),
        });
    }
    return request(requestOptions);
}
Object.assign(request, {
    get: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return requestShortcut.apply(void 0, __spreadArrays(['get'], args));
    },
    post: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return requestShortcut.apply(void 0, __spreadArrays(['post'], args));
    },
    json: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return requestShortcut.apply(void 0, __spreadArrays(['json'], args));
    },
    getJSON: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return requestShortcut.apply(void 0, __spreadArrays(['json'], args));
    },
    postJSON: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return requestShortcut.apply(void 0, __spreadArrays(['postJSON'], args));
    },
});
request.abortController = function () {
    var contoller = {
        canceled: false,
        onAbort: null,
        abort: function () {
            contoller.canceled = true;
            if (contoller.onAbort)
                contoller.onAbort();
        },
    };
    return contoller;
};
request.setup = function setup(options) {
    if (options.type && !options.method) {
        extend_1.extend(options, { method: options.type });
    }
    extend_1.extend(globals, options);
};
exports.default = request;
//# sourceMappingURL=request.js.map